const $product_form = document.querySelector(".product_form");
const product_variants = product.variants;

const getSelectedOptions = () => {
  const selectedOptions = [];
  const inputs = $product_form.querySelectorAll('input[type="radio"]:checked');
  inputs.forEach((input) => {
    const value = input.value;
    selectedOptions.push(value);
  });
  return selectedOptions;
};

const areArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((value, index) => value === sorted2[index]);
};

const getVariantByOptions = (options) => {
  const variant = product_variants.find((variant) =>
    areArraysEqual(variant.options, options)
  );
  return variant;
};

const updateUrl = (variantId) => {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.replaceState({}, "", url);
};

$product_form.addEventListener("change", () => {
  const selectedOptions = getSelectedOptions();
  const variant = getVariantByOptions(selectedOptions);
  const { id, available, price } = variant;

  const $variant_id = $product_form.querySelector("#variant-id");
  $variant_id.value = id;
  updateAvailability(price, available);
  updateUrl(id);
});

const formatPrice = (number) => {
  if (!number) return 0;
  number = number / 100;
  // Convert the number to a string
  let formattedNumber = number.toLocaleString();
  // Convert back to a number
  return formattedNumber;
};

const updateAvailability = (price, available) => {
  // Remove Errors
  const $product_error = document.querySelector(".product_error");
  $product_error.classList.remove("active");

  const $product_ctas = document.querySelector(".product_ctas");
  const comming_soon = $product_ctas.classList.contains("c-s");
  if (comming_soon) return;

  // UPDATE AVAILABILITY
  const $atc_btn = document.querySelector(".product_ctas #add-to-cart");
  const $sold_out_btn = document.querySelector(".product_ctas #sold-out");
  const $product_price = $product_ctas.querySelector(".price");
  if (available) {
    // Update current price
    $product_price.textContent = formatPrice(price);
    $atc_btn.classList.remove("d-n");
    $sold_out_btn.classList.add("d-n");
  } else {
    $atc_btn.classList.add("d-n");
    $sold_out_btn.classList.remove("d-n");
  }
};
